'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const modalContentBody = "_modal-content-body_3bwlc_1";
const modalContentBodyInner = "_modal-content-body-inner_3bwlc_40";
const styles = {
	modalContentBody: modalContentBody,
	modalContentBodyInner: modalContentBodyInner
};

const ModalContentBody = ({ children, textAlign = "start" }) => {
  return React__default.default.createElement(
    "div",
    { className: styles.modalContentBody, "data-text-align": textAlign, "data-zds": true },
    React__default.default.createElement("div", { className: styles.modalContentBodyInner, "data-zds": true }, children)
  );
};

exports.ModalContentBody = ModalContentBody;
//# sourceMappingURL=ContentBody.cjs.js.map
